import sv from './sv'
import Utils from '../Utils'

var svMsg = {
  'agreements.title': 'Avtal',
  'agreements.error.mandatory': "Du måste godkänna för att kunna fortsätta använda Deepers tjänster",
  'agreements.error.blank': "Gör ett val",
  'agreements.back': 'Tillbaka',
  'agreements.agree': 'Godkänn',
  'agreements.decline': 'Avböj',
  'agreements.text.full': 'Hela avtalet'
}

Utils.addTerms(svMsg, sv)

export default svMsg



// WEBPACK FOOTER //
// ./src/lang/svMsg.js